import { render, staticRenderFns } from "./crudImportLog.vue?vue&type=template&id=87c0fce8&"
import script from "./crudImportLog.vue?vue&type=script&lang=js&"
export * from "./crudImportLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports